import { type FC, useEffect, useState } from 'react';
import type { SearchEntrySportSB } from '@mwl/core-lib';
import LinkArrowIcon from '@public/assets/common/icons/arrowRightOutlined.svg';
import { Button } from '@/components/Button/Button';
import { SportIcon } from '@/components/SportIcon/SportIcon';
import { internationalIcon, routes } from '@/constants';
import { analyticsBtn, getAnalytics } from './SportSearchResult.analytics';
import { useMakeSearchResultsVariant } from './SportSearchResult.hooks';
import type { SportSearchResultProps } from './SportSearchResult.types';
import styles from './SportSearchResult.module.scss';
const defaultVisibleCount = 3;
const showMoreCount = 5;
const SportSearchResult: FC<SportSearchResultProps> = ({
  className,
  variant,
  searchResults
}) => {
  const [visibleCount, setVisibleCount] = useState(defaultVisibleCount);
  const {
    searchResultsVariant,
    translations
  } = useMakeSearchResultsVariant(searchResults, variant);
  useEffect(() => {
    setVisibleCount(defaultVisibleCount);
  }, [searchResults]);
  if (!searchResultsVariant || !searchResultsVariant.length) {
    return null;
  }
  const isChampionshipsVariant = variant === 'championships';
  const isShowMore = visibleCount < searchResultsVariant.length;
  const handleShowMore = () => {
    setVisibleCount(prevCount => prevCount + showMoreCount);
  };
  return <div className={cn(styles.root, className)} data-sentry-component="SportSearchResult" data-sentry-source-file="SportSearchResult.tsx">
      <div className={styles.header}>
        <h2 className={styles.title}>{translations.header}</h2>
      </div>

      <div className={styles.list}>
        {(isChampionshipsVariant ? searchResultsVariant.slice(0, visibleCount) : searchResultsVariant).map(searchResultItem => <Button key={searchResultItem.id} className={styles.item} as="link" href={{
        pathname: routes.sport.home,
        query: {
          ...searchResultItem.hrefQuery
        }
      }} variant="filled" color="black-light" uppercase={false} analytics={getAnalytics(variant, searchResultItem)} size="sm" rounded cut={false} title={searchResultItem.title}>
              <SportIcon className={styles.itemIcon} url={(searchResultItem as SearchEntrySportSB).icon ?? internationalIcon} size={24} />
              <span className={styles.itemTitle}>{searchResultItem.title}</span>
              <span className={styles.goTo}>{translations.goTo}</span>
              <span className={styles.arrow}>
                <LinkArrowIcon />
              </span>
            </Button>)}
      </div>

      {isChampionshipsVariant && isShowMore && <Button className={styles.loadMoreButton} as="button" color="red" variant="filled" size="md" rounded fontSize="xl" onClick={handleShowMore} analytics={analyticsBtn}>
          {translations.showMore}
        </Button>}
    </div>;
};
export { SportSearchResult };